/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ActivityHierarchyEmissionsInventoryResponse as ApiActivityHierarchyEmissionsInventoryResponse } from '../models/api/activity-hierarchy-emissions-inventory-response';
import { CoreDataRequiredForV4 as ApiCoreDataRequiredForV4 } from '../models/api/core-data-required-for-v-4';
import { CreatePublishedBoardResponse as ApiCreatePublishedBoardResponse } from '../models/api/create-published-board-response';
import { createPublishedBoard } from '../fn/published-board/create-published-board';
import { CreatePublishedBoard$Params } from '../fn/published-board/create-published-board';
import { createPublishedBoardV3 } from '../fn/published-board/create-published-board-v-3';
import { CreatePublishedBoardV3$Params } from '../fn/published-board/create-published-board-v-3';
import { createV2PublishedBoard } from '../fn/published-board/create-v-2-published-board';
import { CreateV2PublishedBoard$Params } from '../fn/published-board/create-v-2-published-board';

@Injectable({ providedIn: 'root' })
export class PublishedBoardService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createPublishedBoard()` */
  static readonly CreatePublishedBoardPath = '/v1/published-boards';

  /**
   * Create published board.
   *
   * Publish a board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPublishedBoard()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPublishedBoard$Response(
    params: CreatePublishedBoard$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiCoreDataRequiredForV4>> {
    return createPublishedBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Create published board.
   *
   * Publish a board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPublishedBoard$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPublishedBoard(
    params: CreatePublishedBoard$Params,
    context?: HttpContext
  ): Observable<ApiCoreDataRequiredForV4> {
    return this.createPublishedBoard$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiCoreDataRequiredForV4>): ApiCoreDataRequiredForV4 => r.body)
    );
  }

  /** Path part for operation `createPublishedBoardV3()` */
  static readonly CreatePublishedBoardV3Path = '/v1/published-boards/v3';

  /**
   * Create published board on V3.
   *
   * Publish a board on V3, pass gzipped body as binary
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPublishedBoardV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  createPublishedBoardV3$Response(
    params: CreatePublishedBoardV3$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiCreatePublishedBoardResponse>> {
    return createPublishedBoardV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Create published board on V3.
   *
   * Publish a board on V3, pass gzipped body as binary
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPublishedBoardV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  createPublishedBoardV3(
    params: CreatePublishedBoardV3$Params,
    context?: HttpContext
  ): Observable<ApiCreatePublishedBoardResponse> {
    return this.createPublishedBoardV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiCreatePublishedBoardResponse>): ApiCreatePublishedBoardResponse => r.body)
    );
  }

  /** Path part for operation `createV2PublishedBoard()` */
  static readonly CreateV2PublishedBoardPath = '/v2/published-boards';

  /**
   * Create published board.
   *
   * Publish a board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createV2PublishedBoard()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createV2PublishedBoard$Response(
    params: CreateV2PublishedBoard$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActivityHierarchyEmissionsInventoryResponse>> {
    return createV2PublishedBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Create published board.
   *
   * Publish a board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createV2PublishedBoard$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createV2PublishedBoard(
    params: CreateV2PublishedBoard$Params,
    context?: HttpContext
  ): Observable<ApiActivityHierarchyEmissionsInventoryResponse> {
    return this.createV2PublishedBoard$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<ApiActivityHierarchyEmissionsInventoryResponse>
        ): ApiActivityHierarchyEmissionsInventoryResponse => r.body
      )
    );
  }
}
